const API_BASE_URL = "https://api.bugfer.com/v1/"
// const API_BASE_URL = "http://localhost:8000/v1/"

export default {
    API_BASE_URL: API_BASE_URL,
}